var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import BroadcastingMsg from './broadcastingMsg';
import RoomLists from './roomLists';
import { useEndAllRoomsMutation } from '../../../store/services/breakoutRoomApi';
import { useAppDispatch } from '../../../store';
import { updateShowManageBreakoutRoomModal } from '../../../store/slices/bottomIconsActivitySlice';
const BreakoutRoomLists = () => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [disable, setDisable] = useState(false);
    const [endAllRooms, { isLoading, data }] = useEndAllRoomsMutation();
    useEffect(() => {
        setDisable(!!isLoading);
    }, [isLoading]);
    useEffect(() => {
        if (data) {
            if (data.status) {
                toast(t('breakout-room.end-all-success'), {
                    type: 'info',
                });
                dispatch(updateShowManageBreakoutRoomModal(false));
            }
            else {
                toast(t(data.msg), {
                    type: 'error',
                });
            }
        }
    }, [data]);
    const endAll = () => {
        endAllRooms();
    };
    const render = () => {
        return (_jsxs("div", { className: "manage-breakout-room-wrap", children: [_jsx(BroadcastingMsg, {}), _jsx(RoomLists, {}), _jsx("div", { className: "btn pb-3 pt-4 bg-gray-50 dark:bg-transparent flex items-end justify-end", children: _jsx("button", { className: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primaryColor hover:bg-secondaryColor focus:outline-none focus:ring-2 focus:ring-offset-2 focus:bg-secondaryColor", onClick: () => endAll(), disabled: disable, children: t('breakout-room.end-all') }) })] }));
    };
    return render();
};
_react_refresh_temp_1 = BreakoutRoomLists;
$RefreshReg$(_react_refresh_temp_1, "BreakoutRoomLists");
_react_refresh_temp_2(BreakoutRoomLists, "xIIejbRXOZ/PoeHoFeHf4UG6ZQ8=", false, () => [useTranslation, useAppDispatch, useEndAllRoomsMutation]);
export default BreakoutRoomLists;
